import { CREATE_GROUP, FETCH_GROUP, UPDATE_GROUP } from './actions/group'
import { RepositoryFactory } from '@/api/RepositoryFactory'

const GroupAPI = RepositoryFactory.get('group')

export default {
  state: {
    group: [],
  },
  getters: {
    getGroup: state => state.group,
  },
  mutations: {
    [UPDATE_GROUP]: (state, group) => (state.group = group),
    [CREATE_GROUP]: (state, payload) =>
      (state.group = [...state.group, payload]),
  },
  actions: {
    [FETCH_GROUP]: async ({ commit }) => {
      await GroupAPI.getGroup().then(response =>
        commit(UPDATE_GROUP, response.data.items),
      )
    },
    [CREATE_GROUP]: ({ commit }, payload) => commit(CREATE_GROUP, payload),
  },
}
